'use strict';

angular.module('TurneroApp').service('agendaService', ['$resource', 'portal', function ($resource, portal) {
	return $resource(portal.getUrlServer() + 'api/Agenda/:id', { id: '@Id_Agenda' }, {
		get_X_Tramite: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/filtroConsulta/Get_X_Tramite',
            headers: portal.getHeadersServer(),
            cancellable: true
		},
		GetFiltros: {
			method: 'GET',
			//params: { id_centro_atencion: '@id_centro_atencion' },
			url: portal.getUrlServer() + 'api/Agenda/filtro/'
		},
		GetTramites: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/tramites/'
		},
		GetListado: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/listado/'
		},
		Get_Franja: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Franja/'
		},
		Get_Paso1: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Paso1/'
		},
		Put_Agenda_Paso1: {
			method: 'PUT',
			url: portal.getUrlServer() + 'api/Agenda/Paso1/'
		},
		Get_Paso2: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Paso2/'
		},
		Put_Agenda_Paso2: {
			method: 'PUT',
			url: portal.getUrlServer() + 'api/Agenda/Paso2/'
		},
		Get_Paso3: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Paso3/'
		},
		Put_Agenda_Paso3: {
			method: 'PUT',
			url: portal.getUrlServer() + 'api/Agenda/Paso3/'
		},
		Get_Paso4: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Paso4/'
		},
		Put_Agenda_Paso4: {
			method: 'PUT',
			url: portal.getUrlServer() + 'api/Agenda/Paso4/'
		},
		Get_Paso5: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Paso5/'
		},
		Put_Agenda_Paso5: {
			method: 'PUT',
			url: portal.getUrlServer() + 'api/Agenda/Paso5/'
		},
		Duplicar: {
			method: 'POST',
			params: { Id_Agenda: '@Id_Agenda' },
			url: portal.getUrlServer() + 'api/Agenda/Post_Duplicar_Agenda'
		},
		Get_Historial: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Get_Historial/'
		},
		cambiarEstado: {
			method: 'PUT',
			params: {
				//Id_Agenda: '@Id_Agenda',
				Id_Estado_Nuevo: '@Id_Estado_Nuevo'
			},
			url: portal.getUrlServer() + 'api/Agenda/Cambiar_Estado'
		},
		Get_x_Centro_Modalidad: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Get_x_Centro_Modalidad/'
		},
		Get_Info_API: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Get_Info_API/'
		},
		Extender: {
			method: 'PUT',
			params: {
				//Id_Agenda: '@Id_Agenda',
				Fecha_Hasta: '@Fecha_Hasta'
			},
			url: portal.getUrlServer() + 'api/Agenda/Extender/'
		},
		Get_Agendas_Combo_Atencion: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Get_Agendas_Combo_Atencion'
		},
		Get_Agendas_Combo: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Get_Agendas_Combo'
		},
		save: {
			method: 'POST'
		},
		'delete': {
			method: 'DELETE',
			isArray: true

        },
		Recepcion_Agendas_Get: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Recepcion_Agendas_Get/'
        },
        Recepcion_Get_Tramites: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Agenda/Recepcion_Get_Tramites/'
        },
		Muestra_CDD: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Muestra_CDD/'
		},
		Traer_Cantidad_Autorizados: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Traer_Cantidad_Autorizados/'
		},
		Get_Agenda_Telef_Combo: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Agenda/Get_Agenda_Telef_Combo/'
        },
        Tratamiento_Turnos_Req_Reag:{
            method: 'PUT',
            params: {
                Id_Agenda: '@Id_Agenda',
                Id_Estado: '@Id_Estado'
            },
            url: portal.getUrlServer() + 'api/Agenda/Tratamiento_Turnos_Req_Reag'
        }
	});
}]);



// WEBPACK FOOTER //
// ./app/components/agenda/agendaService.js